import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useAuth } from '../../contexts/AuthContext';
import images from '../../components/images';

function ForgetPassword() {
  const { forgotPassword, loading } = useAuth(); // use the context
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
const navigator = useNavigate();
  const onSubmit = async (data) => {
    setSuccessMessage('');
    setErrorMessage('');
    try {
      const response = await forgotPassword(data.email);

    // Assuming forgotPassword() returns an Axios response
    const { success, message, data: resetLink } = response;

    console.log(response.data, 'Forgot password response');

    setSuccessMessage(message || 'If an account exists, a reset link has been sent.');
console.log(resetLink, 'Reset link' , success);
 if (success && resetLink) {
  // Open reset link in a new browser tab
  window.open(resetLink, '_blank');
}


    } catch (error) {

        console.log(error, )
      setErrorMessage(error.message || 'Failed to send reset link');
    }
  };

  return (
    <>
      {/* Top Bar */}
      <div className="fixed top-0 left-0 w-full bg-brandBlue border-b-8 border-brandYellow py-5 z-10"></div>

      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="p-[80px] max-w-[640px] w-full space-y-8 bg-white rounded-[20px] shadow-[0px_0px_20px_0px_#0000001A]">
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <img src={images.logo} alt="Future Forward Logo" className="w-100" />
          </div>

          <form className="mt-8 space-y-6" onSubmit={handleSubmit(onSubmit)}>
            <div className="space-y-4">
              <div className="relative">
                <label htmlFor="email" className="block text-[#717576] font-opensans text-base font-normal">
                  Email or User Name
                </label>
                <input
                  {...register('email', {
                    required: 'Email is required',
                    pattern: {
                      value: /^\S+@\S+$/i,
                      message: 'Invalid email address',
                    },
                  })}
                  type="email"
                  className="input mt-1 rounded-[10px] py-[17px] px-4 bg-[#7175760F] w-full focus:outline-none focus:ring-2 focus:ring-[#7175760F]"
                  placeholder="Enter Your Email or User Name"
                />
                {errors.email && <p className="mt-1 text-sm text-red-600 absolute">{errors.email.message}</p>}
              </div>
            </div>

            {errorMessage && <p className="text-red-600 text-center">{errorMessage}</p>}
            {successMessage && <p className="text-green-600 text-center">{successMessage}</p>}

            <div className="pt-[1.5rem]">
              <button
                type="submit"
                disabled={loading}
                className="btn-primary bg-brandBlue w-full py-[17px] px-4 text-base"
              >
                {loading ? 'Processing...' : 'Send Reset Link'}
              </button>
            </div>

            <div className="text-center pt-[1.5rem]">
              <Link to="/login" className="text-[15px] text-brandBlue hover:text-primary-500">
                Back to Login
              </Link>

              <p className="text-[#717576] font-opensans text-base font-normal mt-4">
                If an account exists with that email, you’ll receive a reset link
              </p>
            </div>
          </form>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="fixed bottom-0 left-0 w-full bg-brandBlue border-t-8 border-brandYellow py-5 z-10"></div>
    </>
  );
}

export default ForgetPassword;
